import { OpsAPI } from '@api';

const defaultOptions = { rowsPerPage: 40, currentPage: 1, search: '' };

const getRefunds = async (options = {}) => {
  const { rowsPerPage, currentPage } = { ...defaultOptions, ...options };
  const params = {
    rows_per_page: rowsPerPage, current_page: currentPage,
  };

  return OpsAPI.getRefunds(params)
    .then(({ data }) => data)
    .catch((error) => Promise.reject(error.response));
};

export { getRefunds };
